"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createElementWithSlate = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
/** Create a React element wrapped in a Plate provider. */
var createElementWithSlate = function createElementWithSlate(plateProps, dndWrapper) {
  var _ref = plateProps || {},
    children = _ref.children,
    _ref$editor = _ref.editor,
    editor = _ref$editor === void 0 ? (0, _plateCommon.createPlateEditor)() : _ref$editor,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    props = _objectWithoutProperties(_ref, ["children", "editor", "onChange", "value"]);
  var plateContent = /*#__PURE__*/_react.default.createElement(_plateCommon.PlateContent, {
    renderEditable: function renderEditable() {
      return children;
    }
  });
  var plate = /*#__PURE__*/_react.default.createElement(_plateCommon.Plate, _objectSpread({
    editor: editor,
    initialValue: value,
    onChange: onChange
  }, props), plateContent);
  if (dndWrapper) {
    return /*#__PURE__*/_react.default.createElement(dndWrapper, null, plate);
  }
  return plate;
};
exports.createElementWithSlate = createElementWithSlate;